import { createBasicSelector } from 'util/redux'
import { emptyObj } from 'util/objects'

import { selectBase } from './selectBase'

export const selectConversationSources = createBasicSelector(
  selectBase,
  base => base.conversationSources || emptyObj
)
